module.exports = __webpack_public_path__ + "static/media/space_x.632778ca.png";